const { v4: uuidv4 } = require('uuid');

const Condition = function () {
  this.context = Condition.CONTEXTS.last_response.flag;
  this.operator = Condition.OPERATORS.equal.flag;

  this.id = uuidv4();
  this.value = '';
  this.destination = '';
  this.variable = '';
};

Condition.CONTEXTS = {
  last_response: { flag: 'last_response', description: 'A última resposta' },
  variable: {
    flag: 'variable',
    description: 'Variável do fluxo',
    variable: true,
  },
};

Condition.OPERATORS = {
  equal: { flag: 'equal', description: 'é igual (==)' },
  not_equal: { flag: 'not_equal', description: 'não é igual (!=)' },
  less: { flag: 'less', description: 'é menor que (<)' },
  greater: { flag: 'greater', description: 'é maior que (>)' },
  less_inclusive: {
    flag: 'less_inclusive',
    description: 'é menor ou igual que (<=)',
  },
  greater_inclusive: {
    flag: 'greater_inclusive',
    description: 'é maior ou igual que (>=)',
  },
  contain: { flag: 'contain', description: 'contém' },
  not_contain: { flag: 'not_contain', description: 'não contém' },
};

module.exports = Condition;
